module.exports = __webpack_public_path__ + "static/media/phone-desc.cd05afeb.png";